import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {styleRule} from "../../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {Flow} from "../../../../FlowState.js";
import {LoadingSpinner} from "../../../../../../core/ui/LoadingSpinner.jsx";
import {Messages} from "../../../../../Messages";
import {Link} from "../../../../../../stem-core/src/ui/UIPrimitives";
import {INLINE_DONATION_URLS, INLINE_EDIT_DONATION_URLS, PAYMENT_DETAILS_PANEL_URL} from "../../../../PanelConstants";
import {UsingCardComponent} from "../../payment-method/components/UsingCardComponent";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {PaymentMethodStore} from "../../../../../../client/state/PaymentMethodStore";
import {DonationStore} from "../../../../../../client/state/DonationStore";
import {BasePanelPage, BasePanelPageStyle} from "../../../../PanelPage";
import {styleRuleInherit} from "../../../../../../stem-core/src/decorators/Style";
import {DonateComponent, DonateComponentStyle} from "../components/DonateComponent";
import {Router} from "../../../../../../stem-core/src/ui/Router";
import {autoredraw} from "../../../../../../stem-core/src/decorators/AutoRedraw";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {Controller} from "../../../../Controller";


export class EditDonationComponent extends DonateComponent {
    updateDonation() {
        Flow.donation.updateDonation(Flow.donation.getTotalAmount());
    }
}

class EditDonationPanelComponentStyle extends DonateComponentStyle {
    @styleRuleInherit
    title = {
        display: "none",
    };
}

@registerStyle(EditDonationPanelComponentStyle)
class EditDonationPanelComponent extends EditDonationComponent {}

class EditDonationPanelStyle extends BasePanelPageStyle {
    @styleRule
    description = {
        display: "inline",
    };

    @styleRule
    inlineLink = {
        ...this.themeProps.PANEL_LINK,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        display: "inline-block",
    };

    @styleRuleInherit
    body = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    }
}

@autoredraw(PaymentMethodStore, DonationStore)
@registerStyle(EditDonationPanelStyle)
export class EditDonationPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.editDonationInlineTitle,
        };
    }

    isButtonDisabled() {
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        return !(Flow.donation.isValid()
            && (Flow.donation.donationAmount !== donation.computeAmount()
                || Flow.donation.payDonationFeeCheckboxChecked !== donation.isDonationFeePaid()
                || donation.getPaymentMethod() !== Controller.paymentMethod.selectedPaymentMethod));
    }

    updateDonation() {
        LoadingSpinner.show();
        this.editDonationComponent.updateDonation();
    }

    render() {
        const {styleSheet} = this;
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        Controller.paymentMethod.initialPaymentMethod = Controller.paymentMethod.selectedPaymentMethod;

        return [
            <div>
                <MessageElement className={styleSheet.description}
                                message={Messages.donatePageRecurringDonationMessage(donation.formatPrice())}/>
                <Link value={Messages.here} className={styleSheet.inlineLink} href={INLINE_EDIT_DONATION_URLS.cancel}/>.
            </div>,
            iFrameMerchantService.isCDSPaymentMethod() ? null :
                <UsingCardComponent card={Controller.paymentMethod.selectedPaymentMethod} hideTitle={true}
                                    onChangeCard={() => Router.changeURL(PAYMENT_DETAILS_PANEL_URL)}
                                    changeCardMessage={Messages.edit} />,
            <EditDonationPanelComponent ref="editDonationComponent" changeURL={this.options.changeURL}
                                        onChange={() => this.redraw()}/>,
            <MerchantButton label={Flow.donation.getEditDonationComponentButtonLabel()}
                            disabled={this.isButtonDisabled()} onClick={() => this.updateDonation()}
                            className={styleSheet.actionButton} ref="button"/>,
        ];
    }

    onMount() {
        super.onMount();

        this.redraw(); // We need this first redraw because we have interdependent components
        this.attachChangeListener(DonationStore, () => {
            if (this.isInDocument()) {
                if (!iFrameUserDataService.getActiveRecurringDonation()) {
                    Router.changeURL(INLINE_DONATION_URLS.donate);
                } else {
                    this.redraw();
                }
            }
        });
    }
}
